export function convertToIranLocalNumber(phoneNumber) {
    if (!phoneNumber) {
        return null;
    }
    // اگر شماره با ' شروع شده باشه، حذفش کن
    if (phoneNumber.startsWith("'")) {
        phoneNumber = phoneNumber.slice(1);
    }

    // بررسی اینکه شماره با +98 شروع شده باشد
    if (phoneNumber?.startsWith('+98')) {
        return '0' + phoneNumber.slice(3);
    }

    // بررسی اینکه شماره با 0098 شروع شده باشد
    if (phoneNumber?.startsWith('0098')) {
        return '0' + phoneNumber.slice(4);
    }

    // اگر از قبل داخلی است (مثلاً 0912...)
    if (phoneNumber?.startsWith('09')) {
        return phoneNumber;
    }

    // اگر هیچکدام نبود، برمی‌گردونه بدون تغییر
    return phoneNumber;
}